import { Platform, useWindowDimensions } from 'react-native';
import { designTokens } from '../theme/design-system';

/** True when running in a web browser at a narrow (mobile) viewport width.
 * Reactive to resize via useWindowDimensions — unlike the module-scope
 * Dimensions.get() snapshots this replaces, which never updated after the
 * window was resized. */
export function useIsMobileBrowser(): boolean {
  const { width } = useWindowDimensions();
  return Platform.OS === 'web' && width < designTokens.breakpoints.tablet;
}
